// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDeftV4fOVD7bbnmKQN-2Wovy2SXO-QUnc",
    authDomain: "portifolio-projects.firebaseapp.com",
    projectId: "portifolio-projects",
    storageBucket: "portifolio-projects.appspot.com",
    messagingSenderId: "673139216793",
    appId: "1:673139216793:web:6f6426ee4b799c8be5c308"
  };

// Use this to initialize the firebase App
const firebaseApp = firebase.initializeApp(firebaseConfig);

// Use these for db & auth
const db = firebaseApp.firestore();
export default db;
